(function () {
    const selectors = {
        image: "video-testimonial__image",
        columns : "video-testimonial__columns"
    };

    const el = document.getElementsByClassName(selectors.image)[0];
    if (el) {
        window.addEventListener('resize', update);
        update();
    }

    function update() {
        let width = window.innerWidth;
        const parent = document.getElementsByClassName(selectors.columns)[0];

        if (parent) {
            let height = parent.offsetHeight;
            if (width < 768) {
                el.style.height = height + "px"
            } else {
                el.style.height = "auto"
            }
        }
    }
})();